<template>
  <div id="extend-session" class="editor-modal">
    <form @submit="confirm">
      <p class="text-muted" v-html="description"></p>
      <input type="text" v-model="loginModel.email" disabled class="extend-session-username" />
      <custom-input
        :inputType="'password'"
        v-model="loginModel.password"
        :name="'passwordInput'"
        :label="'Password'"
        :placeholder="$t('login.login-password-ph')"
        :focusInputField="true"
      />
      <div class="small error text-danger" v-if="error">{{ $t("login.login-error-1") + " " + $t("login.login-error-2") }}</div>

      <div class="footer">
        <button ref="focus" type="submit" class="btn btn-md btn-primary" @click="confirm">
          {{ confirmButtonText || "Ok" }}
          <span v-show="loggingIn"><div class="fa-light fa-circle-notch fa-spin"></div></span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
export default {
  data() {
    return {
      waiting: false,
      error: false,
      loginModel: {
        email: this.userDetails.username,
        password: "",
      },
      loggingIn: false,
    };
  },
  props: {
    title: String,
    description: String,
    onCancel: Function,
    userDetails: Object,
    confirmButtonText: String,
  },
  methods: {
    confirm(evt) {
      evt.preventDefault();
      this.loggingIn = true;
      this.$store.dispatch("logIn", this.loginModel).then(
        (res) => {
          if (res == true) {
            this.$emit("close");
            this.$store.state.handlingExpiredToken = false;
          } else {
            this.error = true;
            this.loggingIn = false;
          }
        },
        (error) => {
          this.error = true;
          this.loggingIn = false;
        },
      );
    },
    cancelClick(evt) {
      console.log(this.$refs.focus);
      evt.preventDefault();
      if (this.onCancel) this.onCancel();
      this.$emit("close");
    },
  },

  components: {
    CustomInput,
  },
};
</script>

<style lang="less">
#extend-session form {
  padding: 30px 25px 25px 25px;
  flex-direction: column;
  h1 {
    font-size: 24px;
    margin: 0;
    margin-right: 15px;
  }
  .text-muted {
    margin: 0;
  }
  .extend-session-username {
    margin: 0;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0.7;
    border: none;
    width: 100%;
    background: none;
  }
  .footer {
    margin-top: 10px;
  }
}
</style>
